import { defaultInitialState } from '../utils';
import { GET_LIST_PLANS, GET_LIST_PLANS_DONE, GET_LIST_PLANS_ERROR, GET_LIST_PLANS_RESET } from './actionTypes';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { data: [] });
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LIST_PLANS:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case GET_LIST_PLANS_DONE:
            return Object.assign(Object.assign({}, state), { data: action.data, isLoading: false, error: false, errorMessage: null });
        case GET_LIST_PLANS_ERROR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case GET_LIST_PLANS_RESET:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map